import React from "react";

const BlogDetails = () => {
  return (
    <>
    <div className="breadcrumb-area">
      <div className="container">
        <div className="breadcrumb-content">
          <h2>Blog Details</h2>
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li className="active">Blog Details</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="hiraola-blog_area hiraola-blog_area-2 hiraola-blog-details hiraola-banner_area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 order-lg-1 order-2">
                        <div className="hiraola-blog-sidebar-wrapper">
                            <div className="hiraola-blog-sidebar">
                                <div className="hiraola-sidebar-search-form">
                                    <form action="javascript:void(0)">
                                        <input type="text" className="hiraola-search-field" placeholder="search here"/>
                                        <button type="submit" className="hiraola-search-btn"><i className="fa fa-search"></i></button>
                                    </form>
                                </div>
                            </div>
                            <div className="hiraola-blog-sidebar">
                                <h4 className="hiraola-blog-sidebar-title">Categories</h4>
                                <ul className="hiraola-blog-archive">
                                    <li><a href="javascript:void(0)">Necklaces (07)</a></li>
                                    <li><a href="javascript:void(0)">Earrings (12)</a></li>
                                    <li><a href="javascript:void(0)">Bracelet (05)</a></li>
                                    <li><a href="javascript:void(0)">Anklet (18)</a></li>
                                    <li><a href="javascript:void(0)">Braid Jewels (13)</a></li>
                                    <li><a href="javascript:void(0)">Foot Harness (06)</a></li>
                                </ul>
                            </div>
                            <div className="hiraola-blog-sidebar">
                                <h4 className="hiraola-blog-sidebar-title">Blog Archives</h4>
                                <ul className="hiraola-blog-archive">
                                    <li><a href="javascript:void(0)">April (05)</a></li>
                                    <li><a href="javascript:void(0)">May (10)</a></li>
                                    <li><a href="javascript:void(0)">June (15)</a></li>
                                    <li><a href="javascript:void(0)">July (20)</a></li>
                                    <li><a href="javascript:void(0)">August(25)</a></li>
                                    <li><a href="javascript:void(0)">September (30)</a></li>
                                </ul>
                            </div>
                            <div className="hiraola-blog-sidebar">
                                <h4 className="hiraola-blog-sidebar-title">Recent Post</h4>
                                <div className="hiraola-recent-post">
                                    <div className="hiraola-recent-post-thumb">
                                        <a href="blog-details-left-sidebar.html">
                                            <img className="img-full" src="assets/images/product/small-size/2-1.jpg" alt="Hiraola's Product Image"/>
                                        </a>
                                    </div>
                                    <div className="hiraola-recent-post-des">
                                        <span><a href="blog-details-left-sidebar.html">First Blog Post</a></span>
                                        <span className="hiraola-post-date">28-05-19</span>
                                    </div>
                                </div>
                                <div className="hiraola-recent-post">
                                    <div className="hiraola-recent-post-thumb">
                                        <a href="blog-details-left-sidebar.html">
                                            <img className="img-full" src="assets/images/product/small-size/2-2.jpg" alt="Hiraola's Product Image"/>
                                        </a>
                                    </div>
                                    <div className="hiraola-recent-post-des">
                                        <span><a href="blog-details-left-sidebar.html">Second Blog Post</a></span>
                                        <span className="hiraola-post-date">28-05-19</span>
                                    </div>
                                </div>
                                <div className="hiraola-recent-post">
                                    <div className="hiraola-recent-post-thumb">
                                        <a href="blog-details-left-sidebar.html">
                                            <img className="img-full" src="assets/images/product/small-size/2-3.jpg" alt="Hiraola's Product Image"/>
                                        </a>
                                    </div>
                                    <div className="hiraola-recent-post-des">
                                        <span><a href="blog-details-left-sidebar.html">Third Blog Post</a></span>
                                        <span className="hiraola-post-date">28-05-19</span>
                                    </div>
                                </div>
                            </div>
                            <div className="hiraola-blog-sidebar">
                                <h4 className="hiraola-blog-sidebar-title">Tags</h4>
                                <ul className="hiraola-blog-tags">
                                    <li><a href="javascript:void(0)">Rings</a></li>
                                    <li><a href="javascript:void(0)">Necklaces</a></li>
                                    <li><a href="javascript:void(0)">Bracelet</a></li>
                                    <li><a href="javascript:void(0)">Earrings</a></li>
                                    <li><a href="javascript:void(0)">Necklaces</a></li>
                                    <li><a href="javascript:void(0)">Braid</a></li>
                                    <li><a href="javascript:void(0)">Harness</a></li>
                                    <li><a href="javascript:void(0)">Graceful Armlet</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-9 order-lg-2 order-1">
                        <div className="blog-item">
                            <div className="blog-img img-hover_effect">
                                <a href="blog-details-left-sidebar.html">
                                    <img src="assets/images/blog/medium-size/2.jpg" alt="Hiraola's Blog Image"/>
                                </a>
                                <div className="blog-meta-2">
                                    <div className="blog-time_schedule">
                                        <span className="day">25</span>
                                        <span className="month">April</span>
                                    </div>
                                </div>
                            </div>
                            <div className="blog-content">
                                <div className="blog-heading">
                                    <h5>
                                        <a href="javascrip:void(0)">Blog Image Post</a>
                                    </h5>
                                </div>
                                <div className="blog-short_desc">
                                    <p>The most popular color is yellow which is made by adding silver and some copper. The
                                        metals are melted together to form an alloy of the desired color and karat. It is very
                                        important that all the ingredients are pure and that the amounts of each are weighed
                                        very accurately to prevent porosity, which weakens the alloy.
                                    </p>
                                </div>
                            </div>
                            <div className="hiraola-blog-blockquote">
                                <blockquote>
                                    <p>The weight of evidence strongly supports a theme of healthful eating while allowing for
                                        variations on that theme. A
                                        diet of minimally processed foods close to nature, predominantly plants, is decisively
                                        associated with health
                                        promotion and disease prevention and is consistent with the salient components of
                                        seemingly distinct dietary
                                        approaches. Efforts to improve public health through diet are forestalled not for want
                                        of knowledge about the
                                        optimal feeding of Homo sapiens but for distractions associated with exaggerated claims,
                                        and our failure to convert
                                        what we reliably know into what we routinely do.
                                    </p>
                                </blockquote>
                            </div>
                            <div className="blog-additional_information">
                                <p>D colored diamonds are the rarest and most expensive of diamonds within the D-Z scale.
                                    Certain fancy colored diamonds will command the highest prices overall, and these will be
                                    discussed in separate tutorial. Many people enjoy diamonds in the near colorless range G-J,
                                    as they find a balance of size, clarity, and price to meet their needs.
                                </p>
                            </div>
                            <div className="hiraola-tag-line">
                                <h4>Tag:</h4>
                                <a href="javascript:void(0)">Vegetables</a>,
                                <a href="javascript:void(0)">Milk Fresh</a>,
                                <a href="javascript:void(0)">Edible Oils</a>
                            </div>
                            <div className="hiraola-social_link">
                                <ul>
                                    <li className="facebook">
                                        <a href="https://www.facebook.com/" data-bs-toggle="tooltip" target="_blank" aria-label="Facebook">
                                            <i className="fab fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li className="twitter">
                                        <a href="https://twitter.com/" data-bs-toggle="tooltip" target="_blank" aria-label="Twitter">
                                            <i className="fab fa-twitter-square"></i>
                                        </a>
                                    </li>
                                    <li className="google-plus">
                                        <a href="https://www.plus.google.com/discover" data-bs-toggle="tooltip" target="_blank" aria-label="Google Plus">
                                            <i className="fab fa-google-plus"></i>
                                        </a>
                                    </li>
                                    <li className="instagram">
                                        <a href="https://rss.com/" data-bs-toggle="tooltip" target="_blank" aria-label="Instagram">
                                            <i className="fab fa-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="hiraola-comment-section">
                                <h3>03 comment</h3>
                                <ul>
                                    <li>
                                        <div className="author-avatar">
                                            <img src="assets/images/blog/user.png" alt="User"/>
                                        </div>
                                        <div className="comment-body">
                                            <span className="reply-btn"><a href="javascript:void(0)">reply</a></span>
                                            <h5 className="comment-author">Edwin Adams</h5>
                                            <div className="comment-post-date">
                                                25 April, 2022 at 10:30am
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim maiores adipisci
                                                optio ex,
                                                laboriosam
                                                facilis non pariatur itaque illo sunt?</p>
                                        </div>
                                    </li>
                                    <li className="comment-children">
                                        <div className="author-avatar">
                                            <img src="assets/images/blog/admin.png" alt="Admin"/>
                                        </div>
                                        <div className="comment-body">
                                            <span className="reply-btn"><a href="javascript:void(0)">reply</a></span>
                                            <h5 className="comment-author">Anny Adams</h5>
                                            <div className="comment-post-date">
                                                25 April, 2022 at 11:00am
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim maiores adipisci
                                                optio ex,
                                                laboriosam
                                                facilis non pariatur itaque illo sunt?</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="author-avatar">
                                            <img src="assets/images/blog/user.png" alt="User"/>
                                        </div>
                                        <div className="comment-body">
                                            <span className="reply-btn"><a href="javascript:void(0)">reply</a></span>
                                            <h5 className="comment-author">Edwin Adams</h5>
                                            <div className="comment-post-date">
                                                25 April, 2022 at 06:50pm
                                            </div>
                                            <p>Thank You :</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="hiraola-blog-comment-wrapper">
                                <h3>leave a reply</h3>
                                <p>Your email address will not be published. Required fields are marked *</p>
                                <form action="javascript:void(0)">
                                    <div className="comment-post-box">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <label>comment</label>
                                                <textarea name="commnet" placeholder="Write a comment"></textarea>
                                            </div>
                                            <div className="col-lg-4 col-md-4">
                                                <label>Name</label>
                                                <input type="text" className="coment-field" placeholder="Name"/>
                                            </div>
                                            <div className="col-lg-4 col-md-4">
                                                <label>Email</label>
                                                <input type="text" className="coment-field" placeholder="Email"/>
                                            </div>
                                            <div className="col-lg-4 col-md-4">
                                                <label>Website</label>
                                                <input type="text" className="coment-field" placeholder="Website"/>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="comment-btn_wrap f-left">
                                                    <div className="hiraola-post-btn_area">
                                                        <a className="hiraola-post_btn" href="javascript:void(0)">Post comment</a>
                                                    </div>
                                                    {/* <!-- <input className="hiraola-post_btn" type="submit" name="submit" value="post comment"> --> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    
    
  );
};

export default BlogDetails;
